import React from 'react';
import ReactDOM from 'react-dom';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./fonts/iconfont.css"
import 'antd/dist/antd.css'
import './styles/main.scss';
import AppCmp from './AppCmp';

ReactDOM.render(<AppCmp/>, document.getElementById('root'));



